<div class="border-2 border-black absolute z-50 right-4 top-4 bg-slate-300 p-2 opacity-80" cdkDrag>
  <h1 class="text-xl flex justify-between align-center">
    Debug

    <app-pan-button icon="close" fill="outline" (click)="debug.toggleDebug()" size="sm"></app-pan-button>
  </h1>

  <div class="text-sm italic">For viewing purposes only!</div>
  <div class="text-sm italic">Will not change how API works!</div>

  <h2 class="text-lg mt-2 flex justify-between align-center">
    Roles

    <div class="flex gap-2">
      <app-pan-button fill="outline" (click)="setMyRoles()" size="sm">Mine</app-pan-button>
      <app-pan-button fill="outline" (click)="debug.resetRoles()" size="sm">Reset</app-pan-button>
    </div>
  </h2>

  @for (role of toggleableRoles; track $index) {
    <div>
      <label>
        <input type="checkbox" panCheckbox (change)="setRole(role, $event)" [checked]="debug.roleOverrides()[role]" />
        {{ role }}
      </label>
    </div>
  }
</div>
